
  export default {
    name: 'Theme2ComponentsNoBonusAvailable',
    props: {
      title: {
        type: String,
        default: ''
      },
      description: {
        type: String,
        default: ''
      },
      showDescription: {
        type: Boolean,
        default: true
      }
    }
  }
